import { DestinationFundingSourceSelector } from '@/src/experiences/points-to-cash-for-mortgage/components/destinationFundingSourceSelector'
import { StandaloneWrapper } from '@/src/common/wrappers/StandaloneWrapper'
import { CashForMortgageStore } from '../statsig/store'
import { router } from 'expo-router'
import { mesaColorNames } from '@/src/common/theme'
import { withPaymentMethodsForCashForMortgage } from '@/src/experiences/points-to-cash-for-mortgage/withPaymentMethodsForCashForMortgage'

const DestinationAccountSelector = withPaymentMethodsForCashForMortgage(
  (paymentMethods) => {
    const { setDestinationAccount } = CashForMortgageStore.useCashForMortgage()

    return (
      <StandaloneWrapper
        screen="/main/points-to-cash-for-mortgage/destination-account"
        title="Turn Points into Cash for Your Mortgage"
        profileProps={{ menuIconProps: { color: mesaColorNames['Mesa - Brand/White #FFFFFF'] } }}
      >
        <DestinationFundingSourceSelector
          setStoredAccount={setDestinationAccount}
          accountListTitle="Destination Account"
          promptForUpdate
          pushToNextScreen={() => {
            router.push({
              pathname: '/main/points-to-cash-for-mortgage/redemption-confirmation',
            })
          }}
          testID="navigate_to_cash_for_mortgage_confirmation"
          paymentMethods={paymentMethods}
        />
      </StandaloneWrapper>
    )
  },
  { allowNonCardMember: true },
)

export const DestinationAccountSelectorScreen = {
  Screen: DestinationAccountSelector,
  Name: 'destination-account',
}
